import { TelegramWebApp } from './types';

export class TelegramAdapter {
    private static instance: TelegramAdapter;
    private webApp: TelegramWebApp | null = null;
    private isScriptLoaded: boolean = false;

    public static getInstance(): TelegramAdapter {
        if (!TelegramAdapter.instance) {
            TelegramAdapter.instance = new TelegramAdapter();
        }
        return TelegramAdapter.instance;
    }

    /**
     * Carica dinamicamente lo script di Telegram.
     * Restituisce una Promise che si risolve quando l'SDK è pronto.
     */
    public async initialize(): Promise<void> {
        if (this.isScriptLoaded && window.Telegram?.WebApp) {
            this.webApp = window.Telegram.WebApp;
            return;
        }

        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://telegram.org/js/telegram-web-app.js';
            script.async = true;
            
            script.onload = () => {
                if (window.Telegram?.WebApp) {
                    this.webApp = window.Telegram.WebApp;
                    this.isScriptLoaded = true;
                    this.webApp.ready();
                    this.webApp.expand(); // Espande sempre a schermo intero
                    resolve();
                } else {
                    reject(new Error("Telegram WebApp object not found after script load."));
                }
            };

            script.onerror = () => reject(new Error("Failed to load Telegram SDK"));
            document.head.appendChild(script);
        });
    }

    public getRawInitData(): string {
        this.ensureInitialized();
        return this.webApp!.initData;
    }

    public setupMainButton(text: string, onClick: () => void): void {
        this.ensureInitialized();
        const btn = this.webApp!.MainButton;
        btn.text = text;
        btn.onClick(onClick);
        btn.show();
    }

    public hideMainButton(): void {
        if (this.webApp) {
            this.webApp.MainButton.hide();
            this.webApp.MainButton.offClick(() => {}); // Cleanup listeners
        }
    }

    public requestPhoneContact(): Promise<boolean> {
        this.ensureInitialized();
        return new Promise((resolve) => {
            // Callback-based API to Promise wrapper
            this.webApp!.requestContact((shared: boolean) => {
                resolve(shared);
            });
        });
    }

    public showAlert(message: string): void {
        this.ensureInitialized();
        this.webApp!.showAlert(message);
    }

    private ensureInitialized(): void {
        if (!this.webApp) {
            throw new Error("TelegramAdapter not initialized. Call initialize() first.");
        }
    }
}
